import React, { Component } from 'react'
import ClimeDocUI from './ClimeDocUI.js'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'

class ClimeDocSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gettingObjects: false,
      selectedBucket: null,
      downloadSubmitted: false,
    }
  }

  render() {
    return (
      <ClimeDocUI
        context={this.props.context}
        bucketList={this.props.bucketList}
        //
        gettingObjects={this.state.gettingObjects}
        selectedBucket={this.state.selectedBucket}
        onGetObjects={this.onGetObjects}
        onCollapseAll={this.onCollapseAll}
        onExpandeAll={this.onExpandeAll}
        onObjectClick={this.onObjectClick}
        onDownloadClick={this.onDownloadClick}
      />
    )
  }

  onGetObjects = (event) => {
    let bucketName = event.currentTarget.getAttribute('data-row-id')
    this.setState({ selectedBucket: bucketName, gettingObjects: true })

    let cacheManager = new CacheManager({
      resource: `/api/su/s3contents/buckets/${bucketName}/objects`,
      cacheKey: CacheKeys.S3Objects(bucketName),
      callback: this.onGetObjectsCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(this.props.context)
  }

  onGetObjectsCallback = (response) => {
    let bucketList = this.props.bucketList;
    let bucket = bucketList.filter(b => b.bucketName === response.bucketName)[0]
    bucket.object = response.object
    this.props.onUpdateBucketList(bucketList)
    this.setState({ gettingObjects: false })
  }

  onCollapseAll = (event) => {
    let bucketName = event.currentTarget.getAttribute('data-row-id')
    this.setState({ selectedBucket: bucketName })

    let bucketList = this.props.bucketList;
    let bucket = bucketList.filter(b => b.bucketName === bucketName)[0]
    this.collapseAll(bucket.object)
    this.props.onUpdateBucketList(bucketList)
  }

  collapseAll(node) {
    if (node === null) return;
    node.hide = true
    for (const child of node.children) {
      this.collapseAll(child); // Recursively traverse child nodes
    }
  }

  onExpandeAll = (event) => {
    let bucketName = event.currentTarget.getAttribute('data-row-id')
    this.setState({ selectedBucket: bucketName })

    let bucketList = this.props.bucketList;
    let bucket = bucketList.filter(b => b.bucketName === bucketName)[0]
    this.expandAll(bucket.object)
    this.props.onUpdateBucketList(bucketList)
  }

  expandAll(node) {
    if (node === null) return;
    node.hide = false
    for (const child of node.children) {
      this.expandAll(child); // Recursively traverse child nodes
    }
  }

  onObjectClick = (event) => {
    let rowId = event.currentTarget.getAttribute('data-row-id')
    const array = rowId.split(':', 2)
    let bucketName = array[0]
    let fileId = array[1]

    let bucketList = this.props.bucketList;
    let bucket = bucketList.filter(b => b.bucketName === bucketName)[0]
    this.objectClick(bucket.object, fileId)
    this.props.onUpdateBucketList(bucketList)
  }

  objectClick(node, fileId) {
    if (node === null) return;
    if (node.fileId === fileId) {
      node.hide = !node.hide
      return
    }

    for (const child of node.children) {
      this.objectClick(child, fileId); // Recursively traverse child nodes
    }
  }

  onDownloadClick = (event) => {
    let rowId = event.currentTarget.getAttribute('data-row-id')
    const array = rowId.split(':', 2)
    let bucketName = array[0]
    let objectKey = array[1].replace(/\//g, '|')
    this.setState({ selectedBucket: bucketName, downloadSubmitted: true })

    let cacheManager = new CacheManager({
      resource: `/api/su/s3contents/buckets/${bucketName}/objects/${objectKey}/fileDownloadSignedUrl`,
      cacheKey: CacheKeys.S3Objects(bucketName),
      callback: this.onDownloadClickCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(this.props.context)
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadSubmitted: false, downloadErrorList: response.errorList })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

}

export default ClimeDocSF
